<div>
  <form [formGroup]="baseFormGroup" #f="ngForm" class="">
      <!-- Vrsta troška -->
      <div class="row">
          <div class="col-lg-3 col-3">
              <div class="form-group row">
                  <div class="col-md-12">
                      <yt-dropdown-picklist 
                          #autofocus
                          [ModelName]="'fakvrstatroska'" 
                          [GetName]="'get'" 
                          [ModelProperty]="'Naziv'"
                          [OrderBy]="'Naziv'" 
                          [AllowAddNew]="true" 
                          [AllowEdit]="true"
                          formControlName="VrstaTroskaID" 
                          [Label]="'TROSAKDOKUMENTSTAVKA.VRSTATROSKA.SINGULAR'"
                          >
                      </yt-dropdown-picklist>
                      <div class="form-error" *ngIf="submitted && fc.VrstaTroskaID.invalid">
                          <span *ngFor="let validation of errorMessages.VrstaTroskaID">
                            <span class="error-message" *ngIf="fc.VrstaTroskaID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                        </span>
                      </div>
                  </div>
              </div>
          </div>
          <!-- Organizaciona jedinica -->
          <div class="col-lg-3 col-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-dropdown-picklist 
                            [ModelName]="'orgjed'"
                            [GetName]="'getParentAndChildByParentID'"
                            [ModelProperty]="'Naziv'"
                            [OrderBy]="'Naziv'"
                            formControlName="OrgJedID"
                            [Label]="'TROSAKDOKUMENTSTAVKA.ORGJED.SINGULAR'"  
                            [ngClass]="{'is-invalid': submitted && fc.OrgJedID.invalid}">
                        </yt-dropdown-picklist>
                        <div class="form-error" *ngIf="submitted && fc.OrgJedID.invalid">
                            <span *ngFor="let validation of errorMessages.OrgJedID">
                              <span class="error-message" *ngIf="fc.OrgJedID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                          </span>
                        </div>                              
                    </div>
                </div>
            </div>
           <!-- Iznos -->
           <div class="col-lg-3 col-3">
                <div class="form-group row">
                    <div class="col-md-12">
                        <yt-number-input-v3
                            name="txtIznos"                                 
                            [Label]="'TROSAKDOKUMENTSTAVKA.IZNOS.SINGULAR'" 
                            formControlName="Iznos"
                            [ngClass]="{'is-invalid': submitted && fc.Iznos.invalid}"
                            >
                        </yt-number-input-v3>
                        <div class="form-error" *ngIf="submitted && fc.Iznos.invalid">
                            <span *ngFor="let validation of errorMessages.Iznos">
                              <span class="error-message" *ngIf="fc.Iznos.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
                          </span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Nema pravo odbitka -->
            <div class="col-lg-3 col-3" *ngIf='false'>
                <div class="form-group row">
                    <label class="col-form-label col-2"><span translate="TROSAKDOKUMENTSTAVKA.NEMAPRAVODBIT.SINGULAR"></span></label>
                    <div class="col-md-1">
                        <input
                            style="width: 20px;"
                            type="checkbox"
                            name="chkNemaPravoOdbit"
                            formControlName="NemaPravoOdbit"
                            >
                        </div>
                    </div>
            </div>
        </div>  
            <div class="form-group row">
                <div class="col-md-12">
                    <yt-text-area [MaxLength]="2000" name="txtOpis" formControlName="Opis" [Label]="'TROSAKDOKUMENTSTAVKA.OPIS.SINGULAR'">
                    </yt-text-area>
                </div>
            </div>

        
          
         
  </form>
</div>